// This standardizes all the slug strings into a simple map
// These are used in to build the url and are the "page name"
const SLUG = {
  HOME: '',
  ACCOUNT_CREATOR: 'account-creator',
  EXPLORER: 'explorer',
  TXBUILDER: 'txbuilder',
  TXSIGNER: 'txsigner',
  XDRVIEWER: 'xdr-viewer',
  TXSUBMITTER: 'txsubmitter',
};
export default SLUG;
